export default __webpack_public_path__ + "static/media/hero_image2.100c3d9e.png";